
import { IM_STATUS, TRTC_STATUS } from "@/util/constants";
const actions = {
  setLogin({ commit }, isLogin) {
    commit('setLogin', isLogin);
  },
  setIM({ commit }, TEFn) {
    commit('setIM', TEFn);
  },
  // 执行TE页面的方法
  setTEFn({ commit }, TEFn) {
    commit('setTEFn', TEFn);
  },
  // 执行IM页面的方法
  setIMFn({ commit }, IMFn) {
    commit('setIMFn', IMFn);
  },
  // 执行控制人员页面的方法
  setMembersFn({ commit }, membersFn) {
    commit('setMembersFn', membersFn);
  },
  // 资料里面的方法
  setTabDataFn({ commit }, tabDataFn) {
    commit('setTabDataFn', tabDataFn);
  },
  // 问卷里面的方法
  setTabQuesFn({ commit }, tabQuesFn) {
    commit('setTabQuesFn', tabQuesFn);
  },
  // 拥有视频流的用户
  setVideoUserList({ commit }, videoUserList) {
    commit('setVideoUserList', videoUserList);
  },
  // 修改拥有视频流的用户
  updateVideoUserList({ commit }, { type, index, userInfo }) {
    commit('updateVideoUserList', { type, index, userInfo });
  },
  // 问卷列表
  setQuesList({ commit }, questionnaireList) {
    commit('setQuesList', questionnaireList);
  },
  // 修改问卷列表
  updateQuesList({ commit }, { type, index, queInfo }) {
    commit('updateQuesList', { type, index, queInfo });
  },
  // 资料列表
  setInformationList({ commit }, informationList) {
    commit('setInformationList', informationList);
  },
  // 修改资料列表
  updateInformationList({ commit }, { type, index, informationInfo }) {
    commit('updateInformationList', { type, index, informationInfo });
  },
  // 选择本地布局设置
  setLocaLayoutConfig({ commit }, locaLayoutConfig) {
    commit('setLocaLayoutConfig', locaLayoutConfig);
  },

  setMeetingLayoutConfigList({ commit }, meetingLayoutConfigList) {
    commit('setMeetingLayoutConfigList', meetingLayoutConfigList);
  },
  setMeetingSenceConfigList({ commit }, meetingSenceConfigList) {
    commit('setMeetingSenceConfigList', meetingSenceConfigList);
  },
  updateUserInfo({ commit }, info) {
    commit('updateUserInfo', info);
  },
  updateRoomInfo({ commit }, info) {
    commit('updateRoomInfo', info);
  },

  // 修改用户信息
  setUserInfo({ commit }, userInfo) {
    commit('setUserInfo', userInfo);
  },
  // 执行TRTC页面的方法
  setTRTCFn({ commit }, TRTCFn) {
    commit('setTRTCFn', TRTCFn);
  },
  // 修改房间信息
  setRoomInfo({ commit }, roomInfo) {
    commit('setRoomInfo', roomInfo);
  },
  setIMStatus({ commit }) {
    commit('setIMStatus', JSON.parse(JSON.stringify(IM_STATUS)));
  },
  // 修改im 初始化状态
  setIMStatus_initialization({ commit }, info) {
    commit('setIMStatus_initialization', info);
  },
  // 修改im ready状态
  setIMStatus_ready({ commit }, info) {
    commit('setIMStatus_ready', info);
  },
  // 修改im 登录状态
  setIMStatus_login({ commit }, info) {
    commit('setIMStatus_login', info);
  },
  // 修改im 加群状态
  setIMStatus_join({ commit }, info) {
    commit('setIMStatus_join', info);
  },


  setTRTCStatus({ commit }) {
    commit('setTRTCStatus', JSON.parse(JSON.stringify(TRTC_STATUS)));
  },
  // 修改trtc 初始化状态
  setTRTCStatus_initialization({ commit }, info) {
    commit('setTRTCStatus_initialization', info);
  },
  // 修改trtc join状态
  setTRTCStatus_join({ commit }, info) {
    commit('setTRTCStatus_join', info);
  },
  // 修改trtc 加载远端流状态
  setTRTCStatus_loadRemote({ commit }, info) {
    commit('setTRTCStatus_loadRemote', info);
  },
  // 修改trtc 创建本地视频状态
  setTRTCStatus_create({ commit }, info) {
    commit('setTRTCStatus_create', info);
  },
  // 修改trtc 发布本地视频状态
  setTRTCStatus_push({ commit }, info) {
    commit('setTRTCStatus_push', info);
  },

  // 修改共享桌面状态
  setIsShareScreen({ commit }, isShareScreen) {
    commit('setIsShareScreen', isShareScreen);
  },

  setMeetingConfig({ commit }, meetingConfig) {
    commit('setMeetingConfig', meetingConfig);
  },
  setMeetingInfo({ commit }, meetingInfo) {
    commit('setMeetingInfo', meetingInfo);
  },
  setConferee({ commit }, conferee) {
    commit('setConferee', conferee);
  },
  setConfereeCurrentStatus({ commit }, confereeCurrentStatus) {
    commit('setConfereeCurrentStatus', confereeCurrentStatus);
  },
  setMeetingCurrentStatus({ commit }, meetingCurrentStatus) {
    commit('setMeetingCurrentStatus', meetingCurrentStatus);
  },
  setSdkAppId({ commit }, sdkAppId) {
    commit('setSdkAppId', sdkAppId);
  },
  // 播放混流地址
  setMcuMixTranscode({ commit }, url) {
    commit('setMcuMixTranscode', url);
  },
  // 提醒问卷填写开关
  setTipsFlag({ commit }, tipsFlag) {
    commit('setTipsFlag', tipsFlag);
  },
  changeTipSurveyInfoList({ commit }, surveyCode) {
    commit('changeTipSurveyInfoList', surveyCode);
  },
  // 维护屏幕分享流实例
  setScreenShareStream({ commit }, screenShareStream) {
    commit('setScreenShareStream', screenShareStream);
  },
  // 设置是否允许生成全局大图
  updateAllowGenerator({ commit }, allowGenerator) {
    commit('updateAllowGenerator', allowGenerator)
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js